import { jwtDecode } from "jwt-decode";
import { taraURL } from "./baseurl";

/**
 * Builds the TARA deep-link URL from the TalentSpotify session in localStorage.
 *
 * The identity is taken from the stored `user` object (so "Login As" /
 * impersonated users are respected). The JWT is passed through as-is and is
 * NOT validated here: if the user is already signed in to TalentSpotify we
 * simply hand the existing token to TARA and let it establish the session.
 */
export const buildTaraEmbedUrl = (path = "tara-agent") => {
  const raw = localStorage.getItem("user");
  if (!raw) return null;

  let user;
  try {
    user = JSON.parse(raw);
  } catch {
    return null;
  }
  if (!user?.token) return null;

  // Prefer the logged-in user's own ids (supports "Login As").
  const employeeId = String(user._id || "");

  let companyId = String(user.companyId || "");
  if (!companyId) {
    try {
      const stored = localStorage.getItem("companyId");
      if (stored) companyId = String(JSON.parse(stored));
    } catch {
      /* ignore */
    }
  }
  if (!companyId) {
    try {
      const payload = jwtDecode(user.token);
      companyId = String(payload?.companyId || "");
    } catch {
      /* ignore */
    }
  }

  if (!companyId || !employeeId) return null;

  const base = (taraURL || "").replace(/\/$/, "");
  const params = new URLSearchParams({ companyId, employeeId, token: user.token });
  return `${base}/${path.replace(/^\//, "")}?${params}`;
};
